// eslint-disable-next-line import/prefer-default-export
export enum NavigationItemTarget {
  BLANK = "_blank",
  SELF = "_self",
  PARENT = "_parent",
  TOP = "_top",
}
